import React, { useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";
import { useLocation, useHref, useParams } from "react-router-dom";

import { ACTIONS as MAIN_ACTIONS } from "../../redux/main";
import { ACTIONS as SEARCH_ACTIONS } from "../../redux/search";
import { ACTIONS as UI_ACTIONS } from "../../redux/ui";
import { ACTIONS as CHAT_ACTIONS } from "../../redux/chat";
import Drawer from "../../components/drawer";
import Container from "../../components/container";
import useLogged from "../../hooks/useLogged";
import StyledMainLayout, { GlobalStyle } from "./styles";
import useSafariBug from "../../hooks/useSafariBug";

const MainLayout = ({
  children,
  style,
  fullHeight,
  noScroll,
  header,
  footer,
}) => {
  useLogged();
  useSafariBug();
  const dispatch = useDispatch();
  const { open: openDrawer } = useSelector((state) => state.ui.drawer);
  const { open: openChat } = useSelector((state) => state.ui.chat);
  const { user } = useSelector((state) => state.main);
  const { init: chatHasInit, chatList } = useSelector((state) => state.chat);
  const { placeHolder, action } = useSelector((state) => state.ui.drawer);
  const { pathname } = useLocation();
  const params = useParams();

  const href = useHref();

  const onSearchChangeHandler = (event) => {
    event.preventDefault();
    if (action === "SEARCH_USERS") {
      dispatch(SEARCH_ACTIONS.setQueryString(event.target.value));
    }

    if (action === "SEARCH_GROUPS") {
      dispatch(SEARCH_ACTIONS.setGroupQueryString(event.target.value));
    }
  };

  const onLogOutClick = () => {
    dispatch(MAIN_ACTIONS.logOutUser());
  };

  const getTotalMargin = (openDrawer, openChat) => {
    let margin = 87;
    if (openDrawer) margin += 153;
    if (openChat) margin += 153;
    return margin;
  };

  const onSearcherClick = () => {
    dispatch(SEARCH_ACTIONS.getSearcherInfo());
  };

  useEffect(() => {
    if (
      pathname.includes("/search") &&
      !pathname.includes("/search/profiles")
    ) {
      dispatch(UI_ACTIONS.openSearchDrawer());
    } else if (pathname.includes("/grupos")) {
      dispatch(UI_ACTIONS.openGroupsDrawer());
    } else {
      dispatch(UI_ACTIONS.closeSearchDrawer());
    }

    if (pathname.includes("/chat")) {
      if (chatHasInit) {
        dispatch(CHAT_ACTIONS.initNewChat({ chatId: params.chatId }));
        dispatch(UI_ACTIONS.openChatMenu());
      }
    } else {
      dispatch(UI_ACTIONS.closeChatMenu());
    }
  }, [pathname, dispatch, chatHasInit]);

  useEffect(() => {
    if (params?.chatId) {
      try {
        localStorage.setItem("ls", `${params?.chatId}`);
      } catch (e) {
        console.log(e);
      }
    }
  }, [params]);

  // useEffect(() => {
  //   const setDocHeight = () => {
  //     document.documentElement.style.setProperty(
  //       "--vh",
  //       `${window.innerHeight * 0.01}px`
  //     );
  //   };

  //   setDocHeight();
  //   window.addEventListener("resize", setDocHeight);

  //   return () => {
  //     window.removeEventListener("resize", setDocHeight);
  //   };
  // }, []);

  return (
    <StyledMainLayout>
      <GlobalStyle />
      <Drawer
        open={openDrawer}
        onLogOutClick={onLogOutClick}
        href={href}
        name={user.name}
        email={user.email}
        onSearchChange={onSearchChangeHandler}
        className="drawer-component"
        searcherPlaceHolder={placeHolder}
        onSearchClick={onSearcherClick}
      />

      <div
        className="menu-layout"
        style={{ marginLeft: `${getTotalMargin(openDrawer, openChat)}px` }}
      >
        <Container>
          {header && <div className="menu-layout-header">{header()}</div>}
          <div className={`menu-layout-content`}>
            <div
              style={{
                ...style,
                height: fullHeight ? "100%" : "auto",
              }}
              className="main-content-container"
            >
              {children}
            </div>
          </div>
          {footer && <div className="menu-layout-footer">{footer()}</div>}
        </Container>
      </div>
    </StyledMainLayout>
  );
};

export default MainLayout;
